import { CharityResource, CharityState } from '@/models/www/store/CharityState';
import { stateStorage } from '@/services/storage.service';
import { defineStore } from 'pinia';

export const useCharityStore = defineStore('charity', {
    state: () => {
        return {
            resources: [],
            noDonationResources: []
        } as CharityState
    },
    getters: {
        getResources: (state) => {
            return state.resources;
        },
        getNoDonation: (state) => {
            return state.noDonationResources
        }
    },
    actions: {
        setCharity(charity: CharityState) {
            this.resources = charity.resources;
            this.noDonationResources = charity.noDonationResources;
        },
        setResources(resources: CharityResource[]) {
            this.resources = resources;
        },
        addResource(resource: CharityResource) {
            this.removeResource(resource.prefix);
            this.resources.push(resource);
        },
        removeResource(prefix: string) {
            this.resources = this.resources.filter(r => r.prefix !== prefix);
        },
        addNoDonationResource(prefix: string) {
            this.removeNoDonationResource(prefix);
            this.noDonationResources.push(prefix);
        },
        removeNoDonationResource(prefix: string) {
            this.noDonationResources = this.noDonationResources.filter(r => r !== prefix);
        }
    },
    persist: {
        enabled: true,
        strategies: [
            { storage: stateStorage },
        ],
    },
})